import React from 'react';
import Navbar from './components/Navbar';
import Login from './pages/Login';

function App() {
  return (
    <>
      <Navbar />
      <Login />
    </>
  );
}

export default App;
